module.exports = __webpack_public_path__ + "static/media/accessory__rainSensor.3003d794.jpg";